import { removeV2ScopeIndicator } from './isSensitiveScope';
export const getScopeGroupI18nKey = (scopeGroup, key = 'label') => {
  const scopeGroupNameKey = removeV2ScopeIndicator(scopeGroup).replace(/\./g, '-');
  return `developer-experience-shared-components.scopes.scopeGroups.${scopeGroupNameKey}.${key}`;
};